import { render } from "./PlaceForm.vue?vue&type=template&id=41c81b0f&scoped=true"
import script from "./PlaceForm.vue?vue&type=script&lang=js"
export * from "./PlaceForm.vue?vue&type=script&lang=js"

import "./PlaceForm.vue?vue&type=style&index=0&id=41c81b0f&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c81b0f"]])

export default __exports__